// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://etherscan.io/address/0x5D39E06b825C1F2B80bf2756a73e28eFAA128ba0
export const POOL_ADDRESSES_PROVIDER = '0x5D39E06b825C1F2B80bf2756a73e28eFAA128ba0';

// IPool https://etherscan.io/address/0xAe05Cd22df81871bc7cC2a04BeCfb516bFe332C8
export const POOL = '0xAe05Cd22df81871bc7cC2a04BeCfb516bFe332C8';

// IPoolConfigurator https://etherscan.io/address/0x83Cb1B4af26EEf6463aC20AFbAC9c0e2E017202F
export const POOL_CONFIGURATOR = '0x83Cb1B4af26EEf6463aC20AFbAC9c0e2E017202F';

// IAaveOracle https://etherscan.io/address/0x985BcfAB7e0f4EF2606CC5b64FC1A16311880442
export const ORACLE = '0x985BcfAB7e0f4EF2606CC5b64FC1A16311880442';

// https://etherscan.io/address/0x5300A1a15135EA4dc7aD5a167152C01EFc9b192A
export const ACL_ADMIN = '0x5300A1a15135EA4dc7aD5a167152C01EFc9b192A';

// IACLManager https://etherscan.io/address/0xEFD5df7b87d2dCe6DD454b4240b3e0A4db562321
export const ACL_MANAGER = '0xEFD5df7b87d2dCe6DD454b4240b3e0A4db562321';

// IPoolDataProvider https://etherscan.io/address/0x53519c32f73fE1797d10210c4950fFeBa3b21504
export const AAVE_PROTOCOL_DATA_PROVIDER = '0x53519c32f73fE1797d10210c4950fFeBa3b21504';

// https://etherscan.io/address/0xcD8B9aC3B72E81fD8A0c9a0dBba583597E48A23a
export const POOL_IMPL = '0xcD8B9aC3B72E81fD8A0c9a0dBba583597E48A23a';

// https://etherscan.io/address/0x898E245D83Ad255Dc57b04978D0b4A12b94a557F
export const POOL_CONFIGURATOR_IMPL = '0x898E245D83Ad255Dc57b04978D0b4A12b94a557F';

// https://etherscan.io/address/0x1D5D386a90CEA8AcEa9fa75389e97CF5F1AE21D3
export const DEFAULT_INCENTIVES_CONTROLLER = '0x1D5D386a90CEA8AcEa9fa75389e97CF5F1AE21D3';

// https://etherscan.io/address/0xC2201708289b2C6A1d461A227A7E5ee3e7fE9A2F
export const EMISSION_MANAGER = '0xC2201708289b2C6A1d461A227A7E5ee3e7fE9A2F';

// ICollector https://etherscan.io/address/0x70CC725B8f05e0f230B05C4e91ABc651E121354f
export const COLLECTOR = '0x70CC725B8f05e0f230B05C4e91ABc651E121354f';

// https://etherscan.io/address/0xB2668573828029917ffbD1e76270373511818498
export const DEFAULT_A_TOKEN_IMPL = '0xB2668573828029917ffbD1e76270373511818498';

// https://etherscan.io/address/0x15F03E5dE87c12cb2e2b8e5d6ECEf0a9E21ab269
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0x15F03E5dE87c12cb2e2b8e5d6ECEf0a9E21ab269';

// https://etherscan.io/address/0xC6cAB8D39D93DC0Bd5986E7Ce5Bb956E30103A43
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0xC6cAB8D39D93DC0Bd5986E7Ce5Bb956E30103A43';

// https://etherscan.io/address/0x56b7A1012765C285afAC8b8F25C69Bf10ccfE978
export const UI_POOL_DATA_PROVIDER = '0x56b7A1012765C285afAC8b8F25C69Bf10ccfE978';

// https://etherscan.io/address/0xe3dFf4052F0bF6134ACb73bEaE8fe2317d71F047
export const UI_INCENTIVE_DATA_PROVIDER = '0xe3dFf4052F0bF6134ACb73bEaE8fe2317d71F047';

// https://etherscan.io/address/0xC7be5307ba715ce89b152f3Df0658295b3dbA8E2
export const WALLET_BALANCE_PROVIDER = '0xC7be5307ba715ce89b152f3Df0658295b3dbA8E2';

// https://etherscan.io/address/0xe10C78A3AC7f016eD2DE1A89c5479b1039EAB9eA
export const GHO_DIRECT_MINTER = '0xe10C78A3AC7f016eD2DE1A89c5479b1039EAB9eA';

export const CHAIN_ID = 1;
export const ASSETS = {
  GHO: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f',
    A_TOKEN: '0x946281A2d0DD6e650d08f74833323D66AE4c8b12',
    V_TOKEN: '0xdec2401c9B0B2E480e627E2a712C11AdDbf46E3e',
    INTEREST_RATE_STRATEGY: '0x87593272C06f4FC49EC2942eBda0972d2F1Ab521',
    ORACLE: '0xD110cac5d8682A3b045D5524a9903E031d70FCCd',
  },
  USDC: {
    decimals: 6,
    id: 1,
    UNDERLYING: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    A_TOKEN: '0x68215B6533c47ff9f7125aC95adf00fE4a62f79e',
    V_TOKEN: '0x4139EcBe83d78ef5EFF0A6eDA6f894Be9D590FC7',
    INTEREST_RATE_STRATEGY: '0x87593272C06f4FC49EC2942eBda0972d2F1Ab521',
    ORACLE: '0x8fFfFfd4AfB6115b954Bd326cbe7B4BA576818f6',
  },
  RLUSD: {
    decimals: 18,
    id: 2,
    UNDERLYING: '0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD',
    A_TOKEN: '0xE3190143Eb552456F88464662f0c0C4aC67A77eB',
    V_TOKEN: '0xACE8a1c0eC12aE81814377491265b47F4eE5D3dD',
    INTEREST_RATE_STRATEGY: '0x87593272C06f4FC49EC2942eBda0972d2F1Ab521',
    ORACLE: '0x26C46B7aD0012cA71F2298ada567dC9Af14E7f2A',
  },
  USTB: {
    decimals: 6,
    id: 3,
    UNDERLYING: '0x43415eB6ff9DB7E26A15b704e7A3eDCe97d31C4e',
    A_TOKEN: '0x4E58a2E433A739726134c83d2f07b2562e8dFdB3',
    V_TOKEN: '0xC435b02dcBef2e9BdE55e28d39f53ddbe0760a2c',
    INTEREST_RATE_STRATEGY: '0x87593272C06f4FC49EC2942eBda0972d2F1Ab521',
    ORACLE: '0x5Ae4D93B9b9626Dc3289e1Afb14b821FD3C95F44',
  },
  USCC: {
    decimals: 6,
    id: 4,
    UNDERLYING: '0x14d60E7FDC0D71d8611742720E4C50E7a974020c',
    A_TOKEN: '0x08b798c40b9AB931356d9aB4235F548325C4cb80',
    V_TOKEN: '0xA0Ec4758d806A3F41532C8E97Ea0c85940182B0f',
    INTEREST_RATE_STRATEGY: '0x87593272C06f4FC49EC2942eBda0972d2F1Ab521',
    ORACLE: '0x14CB2E810Eb93b79363f489D45a972b609E47230',
  },
  USYC: {
    decimals: 6,
    id: 5,
    UNDERLYING: '0x136471a34f6ef19fE571EFFC1CA711fdb8E49f2b',
    A_TOKEN: '0xc167932AC4EEc2B65844EF00D31b4550250536A5',
    V_TOKEN: '0x818d560Bf1e54f92D1089710F9F4b29C2e6c9248',
    INTEREST_RATE_STRATEGY: '0x87593272C06f4FC49EC2942eBda0972d2F1Ab521',
    ORACLE: '0xE8E65Fb9116875012F5990Ecaab290B3531DbeB9',
  },
  JTRSY: {
    decimals: 6,
    id: 6,
    UNDERLYING: '0x8c213ee79581Ff4984583C6a801e5263418C4b86',
    A_TOKEN: '0x844f07AB09aa5dBDCE6A9b1206CE150E1eaDacCb',
    V_TOKEN: '0x327f61fA4BE6F578DB5cc51e40da4eC4361a349c',
    INTEREST_RATE_STRATEGY: '0x87593272C06f4FC49EC2942eBda0972d2F1Ab521',
    ORACLE: '0xfAB6790E399f0481e1303167c655b3c39ee6e7A0',
  },
  JAAA: {
    decimals: 6,
    id: 7,
    UNDERLYING: '0x5a0F93D040De44e78F251b03c43be9CF317Dcf64',
    A_TOKEN: '0xB0EC6c4482Ac1Ef77bE239C0AC833CF37A27c876',
    V_TOKEN: '0x7bd81B1e0137Fc0fa013b1De2Be81180814C5deb',
    INTEREST_RATE_STRATEGY: '0x87593272C06f4FC49EC2942eBda0972d2F1Ab521',
    ORACLE: '0xF77f2537dba4ffD60f77fACdfB2c1706364fA03d',
  },
  VBILL: {
    decimals: 6,
    id: 8,
    UNDERLYING: '0x2255718832bC9fD3bE1CaF75084F4803DA14FF01',
    A_TOKEN: '0xE1CfD16b8E4B1C86Bb5b7A104cfEFbc7b09326dD',
    V_TOKEN: '0xEAf93Fd541f11D2617C2915D02F7fe67bCa71d4f',
    INTEREST_RATE_STRATEGY: '0x87593272C06f4FC49EC2942eBda0972d2F1Ab521',
    ORACLE: '0x5ed77a9D9b7cc80E9d0D7711024AF38C2643C1c4',
  },
} as const;
export const E_MODES = {
  '1': {
    label: 'VBILL / GHO',
    collateralBitmap: '256',
    collateralAssets: ['0x2255718832bC9fD3bE1CaF75084F4803DA14FF01'],
    borrowableBitmap: '1',
    borrowableAssets: ['0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9200,
    liquidationBonus: 10300,
  },
  '2': {
    label: 'USTB / GHO',
    collateralBitmap: '8',
    collateralAssets: ['0x43415eB6ff9DB7E26A15b704e7A3eDCe97d31C4e'],
    borrowableBitmap: '1',
    borrowableAssets: ['0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9200,
    liquidationBonus: 10300,
  },
  '3': {
    label: ' / ',
    collateralBitmap: '0',
    collateralAssets: [],
    borrowableBitmap: '0',
    borrowableAssets: [],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 7200,
    liquidationThreshold: 7900,
    liquidationBonus: 10750,
  },
  '4': {
    label: 'USCC / GHO',
    collateralBitmap: '16',
    collateralAssets: ['0x14d60E7FDC0D71d8611742720E4C50E7a974020c'],
    borrowableBitmap: '1',
    borrowableAssets: ['0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8700,
    liquidationThreshold: 9000,
    liquidationBonus: 10500,
  },
  '5': {
    label: ' / ',
    collateralBitmap: '0',
    collateralAssets: [],
    borrowableBitmap: '0',
    borrowableAssets: [],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8500,
    liquidationThreshold: 8900,
    liquidationBonus: 10310,
  },
  '6': {
    label: 'USYC / GHO',
    collateralBitmap: '32',
    collateralAssets: ['0x136471a34f6ef19fE571EFFC1CA711fdb8E49f2b'],
    borrowableBitmap: '1',
    borrowableAssets: ['0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9200,
    liquidationBonus: 10310,
  },
  '7': {
    label: ' / ',
    collateralBitmap: '0',
    collateralAssets: [],
    borrowableBitmap: '0',
    borrowableAssets: [],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 7700,
    liquidationThreshold: 8300,
    liquidationBonus: 10450,
  },
  '8': {
    label: 'JTRSY / GHO',
    collateralBitmap: '64',
    collateralAssets: ['0x8c213ee79581Ff4984583C6a801e5263418C4b86'],
    borrowableBitmap: '1',
    borrowableAssets: ['0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8900,
    liquidationThreshold: 9100,
    liquidationBonus: 10350,
  },
  '9': {
    label: ' / ',
    collateralBitmap: '0',
    collateralAssets: [],
    borrowableBitmap: '0',
    borrowableAssets: [],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 7100,
    liquidationThreshold: 7800,
    liquidationBonus: 10900,
  },
  '10': {
    label: 'JAAA / GHO',
    collateralBitmap: '128',
    collateralAssets: ['0x5a0F93D040De44e78F251b03c43be9CF317Dcf64'],
    borrowableBitmap: '1',
    borrowableAssets: ['0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8800,
    liquidationThreshold: 9000,
    liquidationBonus: 10500,
  },
} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0x34039100cc9584Ae5D741d322e16d0d18CEE8770',
  BORROW_LOGIC: '0x62325c94E1c49dcDb5937726aB5D8A4c37bCAd36',
  LIQUIDATION_LOGIC: '0x4731bF01583F991278692E8727d0700a00A1fBBf',
  POOL_LOGIC: '0xf8C97539934ee66a67C26010e8e027D77E821B0C',
  SUPPLY_LOGIC: '0x185477906B46D9b8DE0DEB73A1bBfb87b5b51BC3',
} as const;
